export const isStructuredXmlFile = (file: File): boolean =>
  file.type === 'application/xml' || file.type === 'text/xml' || /\.xml$/i.test(file.name);

// Browsers can report an empty or generic MIME type for XML files. The storage
// API validates the MIME type before the importer validates the XML contents.
export const normalizeDocumentUploadFile = (file: File): File =>
  isStructuredXmlFile(file) && file.type !== 'application/xml' && file.type !== 'text/xml'
    ? new File([file], file.name, {type: 'application/xml', lastModified: file.lastModified})
    : file;
